import axios from 'axios';
import api from './axios';

// A client link authorizes only that client's forms, without a CRM login.
export function createClientApi(linkToken) {
  if (!linkToken) return api;

  const clientApi = axios.create({ baseURL: api.defaults.baseURL });
  let access = null;
  let pendingAccess = null;

  const resolveAccess = () => {
    if (access) return Promise.resolve(access);
    if (!pendingAccess) {
      pendingAccess = clientApi.get(`/cliente/token/${encodeURIComponent(linkToken)}`, {
        skipClientAuth: true,
      }).then((response) => {
        if (!response.data.status || !response.data.clienteId || !response.data.accessToken) {
          throw new Error('Link inválido ou expirado. Abra o link individual enviado pela assessoria.');
        }
        access = response;
        sessionStorage.setItem('clientAuthToken', response.data.accessToken);
        return response;
      }).finally(() => { pendingAccess = null; });
    }
    return pendingAccess;
  };

  clientApi.resolveAccess = resolveAccess;
  clientApi.interceptors.request.use(async (config) => {
    if (!config.skipClientAuth) {
      const { data } = await resolveAccess();
      config.headers.Authorization = `Bearer ${data.accessToken}`;
    }
    return config;
  });
  clientApi.interceptors.response.use((response) => response, async (error) => {
    const config = error.config;
    if (error.response?.status === 401 && config && !config.skipClientAuth && !config.clientAccessRetried) {
      config.clientAccessRetried = true;
      // Parallel failures reuse the refreshed session instead of issuing more tokens.
      if (config.headers.Authorization === `Bearer ${access?.data.accessToken}`) access = null;
      await resolveAccess();
      return clientApi.request(config);
    }
    return Promise.reject(error);
  });
  return clientApi;
}

export function getClientFormLink(formId, linkToken) {
  return `/preencher/${encodeURIComponent(formId)}?acesso=${encodeURIComponent(linkToken)}`;
}
